import React from "react";

// Brand atom — uploaded Hansa logo + wordmark.
// `size` controls just the logo; the text scales with parent typography.
export const HansaLogo = ({ size = 36, withText = true, className = "" }) => (
  <div className={`flex items-center gap-2 ${className}`} data-testid="hansa-brand">
    <img
      src="/hansa-logo.jpeg"
      alt="Hansa — Sanket, संस्थापक किसान"
      width={size}
      height={size}
      className="rounded-full object-cover shrink-0 shadow-sm ring-2 ring-[#1B4332]/20"
      style={{ width: size, height: size, objectPosition: "50% 25%" }}
    />
    {withText && (
      <div className="leading-tight">
        <div className="cd-heading font-extrabold text-[#1B4332] text-lg tracking-tight">
          हंसा
        </div>
        <div className="text-[10px] font-semibold text-[#52796F] -mt-0.5">
          Ramkishan Agri Innovate
        </div>
      </div>
    )}
  </div>
);

export const PoweredByBadge = ({ className = "" }) => (
  <div className={`flex items-center gap-1.5 text-xs text-[#52796F] ${className}`} data-testid="powered-by-badge">
    <span>Powered by</span>
    <span className="font-bold text-[#1B4332]">Ramkishan Agri Innovate</span>
  </div>
);
